module.exports = __webpack_public_path__ + "static/media/mini-group.277fb0ae.jpg";